<template>
  <div class="header">
    <div class="headerWrap">
      <!-- <img src="../../../assets/exam/logo.png" alt="" /> -->
      <div class="logo">
        <span>职业技能等级考试系统</span>
      </div>
      <div class="detail">
        <div class="name">您好！{{ user.name }}</div>
        <div class="out" @click="out">退出</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie, removeCookie } from "@/utils/cookies";
export default {
  data() {
    return {
      user: {},
    };
  },
  created() {
    this.user = getCookie("userInfo");
  },
  methods: {
    out() {
      removeCookie("userInfo");
      removeCookie("myToken");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  background-color: #fff;
  .headerWrap {
    width: 1200px;
    margin: 0 auto;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      span {
        display: block;
        height: 24px;
        line-height: 22px;
        position: relative;
        font-size: 18px;
        font-weight: 500;
        color: #3671bf;
        // border-left: 1px solid #c1c8d1;
        padding-left: 12px;
      }
    }
    .detail {
      display: flex;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #808080;
      .out {
        color: #3671bf;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>
